import { ChevronUpIconComponent } from '../../../shared/components/icons/chevron-up-icon.component';
import { ChevronDownIconComponent } from '../../../shared/components/icons/chevron-down-icon.component';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ProductService } from '../../../shared/service/product.service';
import { BaseComponent } from '../../../base/components/base.component';
import { FaqData } from '../../../shared/models/faqs';
import { FAQType, NoxInverterType } from '../../../shared/models/enum';
import { INVERTER_TYPE } from '../../../shared/service/storage.service';
import { Subject, takeUntil } from 'rxjs';
import { ClickableDirective } from '../../../shared/directives/clickable.directive';
@Component({
    selector: 'app-faqs',
    imports: [CommonModule, ClickableDirective, ChevronDownIconComponent, ChevronUpIconComponent],
    templateUrl: './faqs.component.html',
    styleUrl: './faqs.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FAQsComponent extends BaseComponent implements OnInit, OnDestroy {
  expanddont = false;
  toggleDont(_t47: number) {
    this.expanddont = true;
    this.cdr.markForCheck();
  }
  expanddoes = false;
  toggleDos(index: number) {
    this.expanddoes = true;
    this.cdr.markForCheck();
  }
  private readonly productService = inject(ProductService);
  private readonly cdr = inject(ChangeDetectorRef);
  faqData: FaqData[] = [];
  faqDefaultData: FaqData[] = [];
  dosList: string[] = [];
  dosDefaultList: string[] = [];
  dontList: string[] = [];
  dontDefaultList: string[] = [];

  selectedType: FAQType = FAQType.faq;
  faqType = FAQType;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private readonly _location: Location) {
    super();
  }

  ngOnInit(): void {
    this.baseUserService.sessionService.startBnWatch(this.router);
    let inverterType = this.fetchInverterType();
    this.resolveAllSubscriptions([
      this.fetchFaqsAndDosAndDonts(inverterType),
      this.fetchDonsAndDont(inverterType),
    ]);
  }
  fetchDonsAndDont(category: string): Subject<boolean> {
    let returnSubject = new Subject<boolean>();
    this.productService
      .fetchDosAndDont(category, 'false')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (dosDontResponse) => {
          this.dosList = [];
          this.dontList = [];
          dosDontResponse.data.dos.forEach((element) => {
            this.dosList.push(element);
          });

          dosDontResponse.data.dont.forEach((element) => {
            this.dontList.push(element);
          });
          this.dosDefaultList = this.dosList;
          this.dontDefaultList = this.dontList;
          this.cdr.markForCheck();
          returnSubject.next(true);
        },
        error: (err) => {
          this.logger.error(err);
          returnSubject.next(true);
        },
        complete: () => {
          returnSubject.complete();
        },
      });
    return returnSubject;
  }
  fetchInverterType(): string {
    let inverterType = this.storageService.get(INVERTER_TYPE);

    let category: string = '4';
    switch (inverterType) {
      case NoxInverterType.GTI:
        category = '1';
        break;

      case NoxInverterType.PCU:
        category = '2';
        break;

      case NoxInverterType.REGALIA_W:
        category = '3';
        break;
      case NoxInverterType.REGALIA_F:
        // Default value, no change needed
        break;
      case NoxInverterType.ZELIO:
        category = '6';
        break;
      case NoxInverterType.ZELIO_WIFI_V2:
        category = '7';
        break;
      case NoxInverterType.ICRUZE:
        category = '8';
        break;
      case NoxInverterType.SOLARVERTERPRO:
        category = '9';
        break;
      case NoxInverterType.HYBRID:
        category = '10';
        break;
      case NoxInverterType.LIIONSOLARVERTER:
        category = '11';
        break;
      case NoxInverterType.LITHIUMVERTER:
        category = '12';
        break;
      case NoxInverterType.OPTIMUS:
        category = '13';
        break;
      case NoxInverterType.BATTERY:
        category = '15';
        break;
      case NoxInverterType.THINKPOWER:
        category = '1';
        break;
      default:
        category = '14';
        break;
    }
    return category;
  }

  toggleAnswer(faq: FaqData) {
    faq.expand = !faq.expand;
    this.cdr.markForCheck();
  }
  /**
   * Fetch FAQs and Dos and Donts data
   */
  fetchFaqsAndDosAndDonts(category: string): Subject<boolean> {
    let loaderSubject = new Subject<boolean>();
    this.productService
      .fetchFaqs(category, 'false')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (faqResponse) => {
          let faqs: FaqData[] = [];
          faqResponse.data.forEach((element) => {
            faqs.push({
              question: element.question,
              answer: element.answer,
              expand: false,
            });
          });
          this.faqDefaultData = faqs;
          this.faqData = this.faqDefaultData;
          this.cdr.markForCheck();
          loaderSubject.next(true);
        },
        error: (err) => {
          this.logger.error(err);
          loaderSubject.next(true);
        },
        complete: () => loaderSubject.complete(),
      });

    return loaderSubject;
  }
  /**
   *
   * @param type Update selected type
   */
  updateSelectedType(type: FAQType) {
    switch (type) {
      case FAQType.faq:
        this.selectedType = FAQType.faq;
        break;
      case FAQType.dos:
        this.selectedType = FAQType.dos;
        break;
      case FAQType.dont:
        this.selectedType = FAQType.dont;
        break;
      default:
        break;
    }
    this.cdr.markForCheck();
  }

  /**
   *  onSearchFilter
   */
  onSearchFilter(value: string) {
    this.faqData = this.faqDefaultData;
    this.dosList = this.dosDefaultList;
    this.dontList = this.dontDefaultList;

    switch (this.selectedType) {
      case FAQType.faq:
        this.faqData = this.faqDefaultData.slice().filter((faq) => {
          return faq.question.toLowerCase().includes(value.toLowerCase());
        });
        break;
      case FAQType.dos:
        this.dosList = this.dosDefaultList.slice().filter((dos) => {
          return dos.toLowerCase().includes(value.toLowerCase());
        });
        break;
      case FAQType.dont:
        this.dontList = this.dontDefaultList.slice().filter((dont) => {
          return dont.toLowerCase().includes(value.toLowerCase());
        });

        break;
      default:
        break;
    }
    this.cdr.markForCheck();
  }
  goBack(): void {
    this._location.back();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.baseUserService.sessionService.stopBnTimer();
  }

  data = [
    {
      description:
        'Lorem Ipsum is simply dummy the printing and typesetting industry',
      icon: 'assets/images/customer_screens/half-arrow.svg',
    },
    {
      description:
        'Lorem Ipsum is simply dummy the printing and typesetting industry',
      icon: 'assets/images/customer_screens/half-arrow.svg',
    },
    {
      description:
        'Lorem Ipsum is simply dummy the printing and typesetting industry',
      icon: 'assets/images/customer_screens/half-arrow.svg',
    },
    {
      description:
        'Lorem Ipsum is simply dummy the printing and typesetting industry',
      icon: 'assets/images/customer_screens/half-arrow.svg',
    },
    {
      description:
        'Lorem Ipsum is simply dummy the printing and typesetting industry',
      icon: 'assets/images/customer_screens/half-arrow.svg',
    },
    {
      description:
        'Lorem Ipsum is simply dummy the printing and typesetting industry',
      icon: 'assets/images/customer_screens/half-arrow.svg',
    },
    {
      description:
        'Lorem Ipsum is simply dummy the printing and typesetting industry',
      icon: 'assets/images/customer_screens/half-arrow.svg',
    },
    {
      description:
        'Lorem Ipsum is simply dummy the printing and typesetting industry',
      icon: 'assets/images/customer_screens/half-arrow.svg',
    },
  ];
}
